import * as React from 'react';

export type CardProps = {
  /** Contains elements inside the card `<Card.Header/>`, `<Card.Subeader/>`, `<Card.Content/>` or `<Card.Divider/>`. */
  children?: React.ReactNode;
  /** Contains elements that control the component (usually a <CloseButton/>). */
  controls?: React.ReactNode;
  /** Makes a card stretch vertically to max height in a layout or container. */
  stretchVertically?: boolean;
  /** Hides a portion of card content that overflows its dimensions. */
  hideOverflow?: boolean;
  /** Applies a drop shadow effect. */
  showShadow?: boolean;
  /** Applies a data-hook HTML attribute to be used in the tests. */
  dataHook?: string;
  /**
   * Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Applies highlighting effect on the borders of the component. */
  highlight?: 'focus';
}
